import { render, staticRenderFns } from "./clause-tip.vue?vue&type=template&id=93850842&scoped=true&"
import script from "./clause-tip.vue?vue&type=script&lang=js&"
export * from "./clause-tip.vue?vue&type=script&lang=js&"
import style0 from "./clause-tip.vue?vue&type=style&index=0&id=93850842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93850842",
  null
  
)

export default component.exports